// extracted by mini-css-extract-plugin
export var closeButton = "useModal-module--close-button--f9df9";
export var disableDocumentScroll = "useModal-module--disable-document-scroll--e0a5f";
export var grey = "useModal-module--grey--d66fa";
export var inlineUppb80n = "useModal-module--inline-uppb80n--dbf7b";
export var inlineUppb81j = "useModal-module--inline-uppb81j--9df2f";
export var modal = "useModal-module--modal--2fb2c";
export var navy = "useModal-module--navy--1a999";
export var overlay = "useModal-module--overlay--37911";
export var referralModal = "useModal-module--referralModal--9b8f7";